<template>
    <div>
        <form action="/thread/create" method="POST">
            <input type="hidden" name="_token" :value="csrf_token">
            <input name="title" type="text" placeholder="タイトルを入力" required v-model="title">
            <textarea name="content" placeholder="本文を入力" required v-model="content"></textarea>
            <select name="topic_id">
                <option value="0" selected></option>
                <option v-for="topic in topic_list" :value="topic.topic_id">{{ topic.title }}</option>
            </select>
            <button type="submit" v-bind:disabled="title=='' || content==''">作成する</button>
        </form>
    </div>
</template>

<script>
    export default {
        name: "thread-create",
        props: ['csrf_token'],
        data: function () {
            return {
                title: '',
                content: '',
                topic_list: [],
            }
        },
        mounted() {
            this.getTopicList();
        },
        methods: {
            getTopicList: function() {
                axios.default
                    .get('/topic/list')
                    .then(response => {
                        if(this.topic_list.length == 0) {
                            this.topic_list = response.data;
                        } else {
                            this.topic_list = this.topic_list.concat(response.data);
                        }
                    });
            }
        }
    }
</script>
